import {
  Box,
  Divider,
  InputAdornment,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { InfoIcon } from "components";
import { LogoConfigItem } from "./components/LogoConfigItem";
import { PositionConfigItem } from "./components/PositionConfigItem";
import { SizeConfigItem } from "./components/SizeConfigItem";
import { TextConfigItem } from "./components/TextConfigItem";

export const SignatureConfigSection = (props: {
  options: any[];
  isLoading: boolean;
  showInfo?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Stack
      flex={1}
      direction="column"
      sx={{
        height: "100%",
        overflowY: "auto",
        px: "24px",
        py: "8px",
        pb: "100px",
        gap: "16px",
      }}
    >
      {props.showInfo && (
        <Stack
          direction={"row"}
          gap="8px"
          alignItems={"center"}
          p={"8px"}
          bgcolor={"#FFF4CB"}
          borderRadius={"8px"}
        >
          <InfoIcon
            sx={{
              fontSize: "20px",
              color: "#F3C423",
            }}
          />
          <Typography variant="body-small" flex={1}>
            Changes made to the signature here will also get reflected in the
            original signature.
          </Typography>
        </Stack>
      )}
      <Stack
        sx={{
          gap: "32px",
          py: "16px",
        }}
        divider={
          <Divider
            sx={{ borderColor: theme.palette.neutral["010"] }}
            flexItem
          />
        }
      >
        <TextConfigItem {...props} />
        <LogoConfigItem isLoading={props.isLoading} />
        <PositionConfigItem isLoading={props.isLoading} />
        <SizeConfigItem isLoading={props.isLoading} />
      </Stack>
    </Stack>
  );
};
